import React, {useState} from "react";
import {Navbar, Nav, Container, NavDropdown} from "react-bootstrap";
import {
  useMutation,
} from "@apollo/client";
import {localStorage} from "window-or-global";;
import root from "window-or-global";
import {logoutMutation} from "../logic/user";
import Main from "../main";
import {Fade as Burger} from "../react-burger";
import LogoutIcon from "../../images/logout.svg";
import AuthIcon from "../../images/icon_authenticator.svg";
import UtasLogo from "../../images/utas/utas_net_logo.svg";

export default function Index(props) {
  return (
    <Main>
      <Header {...props} />
    </Main>
  );
}

function Header() {
  const [showMenu, setShowMenu] = useState(false);
  const [logout] = useMutation(logoutMutation);
  const pathname = (root.location || {}).pathname || "";

  async function onHandleLogout() {
    await logout();
    localStorage.removeItem("authToken");
    root.location = "/login/";
  }

  const isActive = (path) => pathname === path;
  const isMfaPage =  pathname.startsWith("/mfa") && (pathname === "/mfa" || pathname === "/mfa/");

  return (
    <header className="portal-header">
      <Container>
        <Navbar variant="light" expand="lg">
          <Navbar.Brand href="" target="_blank">
            <img src={UtasLogo} alt="logo" className="header-logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <Burger direction="right"/>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="portal-header-wide"
            >
              {isMfaPage ?
                <Nav.Link href="/portal" className="nav-link home">{"Home"}</Nav.Link>
                :
                <Nav.Link href="/portal" disabled className="nav-link home-active">{"Home"}</Nav.Link>
              }
              <Nav.Link href="" className="nav-link contact-us">{"Contact Us"}</Nav.Link>

              <NavDropdown
                className="portal-header-dropdown"
                title={<Burger direction="right"/>}
                onClick={() => setShowMenu(prev => !prev)} show={showMenu}
                menuAlign={{lg: "right"}}
              >
                <NavDropdown.Item active={isActive("/mfa")} href="/mfa"><img src={AuthIcon}/>{"2-Step Verification"}</NavDropdown.Item>
                <NavDropdown.Item onClick={() => onHandleLogout()}><img src={LogoutIcon}/>{"Logout"}</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link className="ph-link hidden-on-expand" href="/mfa">{"2-Step Verification"}</Nav.Link>
              <Nav.Link className="ph-link hidden-on-expand" onClick={() => onHandleLogout()}>{"Logout"}</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  );
}
